import { NgModule } from '@angular/core';
import { WfilterPipe } from './pipes/wfilter.pipe';

@NgModule({
  declarations: [WfilterPipe],
  imports: [
  ],
  exports: [WfilterPipe]
})
export class WngxFilterModule { }
